export enum DeviceStatus {
  Active = 1,
  Disabled = 2, 
  Blocked = 4,
  NotConnected = 5,
}

export enum DeviceConnectionStatus {
  Online = 1,
  Offline = 2,
}

export type NewDeviceModel = {
  id: string
  createdAt: string
  lastModifiedAt: string
  isDeleted: boolean
  deletedAt: string
  isBlocked: boolean
  blockedAt: string
  blockedReason: string
  isDisabledByUser: boolean
  disabledAt: string
  userId: string
  key: string
  status: DeviceConnectionStatus
  name: string
  deviceId: string
  battery: number
  network: number
  lastPingedAt: string
  qrCode: string
}

export type DeviceModel = {
  id: string
  createdAt: string
  lastModifiedAt: string
  isDeleted: boolean
  deletedAt: string
  isBlocked: boolean
  blockedAt: string
  blockedReason: string
  isDisabledByUser: boolean
  disabledAt: string
  userId: string
  key: string
  status: DeviceConnectionStatus
  name: string
  deviceId: string
  battery: number
  network: number
  lastPingedAt: string
  qrCode: string
  deviceStatus: DeviceStatus
}

export type NewNameDeviceModel = {
  id: string
  name: string
}

export type NewStatusDeviceModel = {
  id: string
  status: number
}

export const defaultDeviceData: DeviceModel = {
  id: '',
  createdAt: '',
  lastModifiedAt: '',
  isDeleted: false,
  deletedAt: '',
  isBlocked: false,
  blockedAt: '',
  blockedReason: '',
  isDisabledByUser: false,
  disabledAt: '',
  userId: '',
  key: '',
  status: 2,
  name: '',
  deviceId: '',
  battery: 0,
  network: 0,
  lastPingedAt: '',
  qrCode: '',
  deviceStatus: 2,
}

export const defaultDevicesData: DeviceModel[] = [
  {
    id: '',
    createdAt: '',
    lastModifiedAt: '',
    isDeleted: false,
    deletedAt: '',
    isBlocked: false,
    blockedAt: '',
    blockedReason: '',
    isDisabledByUser: false,
    disabledAt: '',
    userId: '',
    key: '',
    status: 2,
    name: '',
    deviceId: '',
    battery: 0,
    network: 0,
    lastPingedAt: '',
    qrCode: '',
    deviceStatus: 2,
  },
]
